const INPUT_CLASS =
  'bg-soFresh-110 text-soClean-100 block w-full rounded-md border border-soFresh-140 py-1.5 placeholder:text-soClean-170 sm:text-sm sm:leading-6';
const READ_ONLY_INPUT_CLASS = `${INPUT_CLASS} bg-soFresh-120 cursor-not-allowed`;
const FULL_WIDTH = 'space-y-1 w-full';
const HALF_WIDTH = 'space-y-1 w-[calc(50%-0.5rem)]';
const ERROR_CLASS = 'text-roses mt-1 text-xs';

export const MEMBER_ACCOUNT_INFO_INPUT_CLASSES = {
  ERROR_CLASS,
  FULL_WIDTH,
  HALF_WIDTH,
  INPUT_CLASS,
  READ_ONLY_INPUT_CLASS
};
